import Intent from './_intent.js'
import FlexPane from './_flex-pane.js'
import Notification from './_notification.js'
import Button from './_button.js'
import NotificationsMap from './_notifications-map.js'

export default {
  name: 'BetslipNotifications',
  values: {
    showDepositOnInsufficientFunds: false,
    showBetslipNotice: false,
    depositIntent: {
      configSet: Intent,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '8px',
          flexDirection: 'column',
        },
      },
    },
    error: {
      configSet: Notification,
      configValues: {},
    },
    warning: {
      configSet: Notification,
      configValues: {},
    },
    info: {
      configSet: Notification,
      configValues: {
        icon: {
          src: 'info',
        },
      },
    },
    depositButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexShrink: 0,
          },
        },
      },
    },
    notificationsMap: {
      configSet: NotificationsMap,
      configValues: {
        MAX_SELECTION_BREACH: 'info',
        INSUFFICIENT_FUNDS: 'warning',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
